const items = document.getElementsByClassName('portfolio-preview-item');

let maxHeight = 0;
let currentHeight;


window.addEventListener('resize', calculateHeightsForPortfolioItems);

function calculateHeightsForPortfolioItems() {
    if(items){
        // calculate height of the highest element
        for (let item of items){
            currentHeight = item.offsetHeight;

            if(currentHeight > maxHeight){
                maxHeight = currentHeight;
            }
        }

        // set height of all elements accordingly
        for(let item of items){
            $(item).css('min-height', maxHeight);
        }
    }
}

calculateHeightsForPortfolioItems();